export default function (obj) {
    return typeof obj !== 'undefined';
}